import { logWarn } from "./logging"; // Import logging utility

export const formatTimestamp = (timestamp: string | number | Date): string => {
  const date = new Date(timestamp);

  // Basic formatting, can be made more sophisticated later
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // Using 24-hour format for simplicity, can be true if AM/PM is preferred
  };

  try {
    return new Intl.DateTimeFormat(navigator.language, options).format(date);
  } catch (e) {
    // Fallback for environments where navigator.language might not be available or is problematic
    // Or if Intl.DateTimeFormat fails for any reason with the provided language tag
    logWarn(
      "Could not format date using browser's language, using default.",
      e,
    );
    return new Intl.DateTimeFormat("en-US", options).format(date);
  }
};
